import { UserConfiguration } from "@app/core/user/domain/user-configuration";
import { Observable } from "rxjs";

/**
 * User configuration repository.
 */
export abstract class UserConfigurationRepo {
  /**
   * Get the user configuration
   * @param token The token of the user.
   */
  abstract get(token: string): Observable<UserConfiguration | null>;

  /**
   * Create or update the user configuration
   * @param token The token of the user.
   * @param userConfiguration The user configuration.
   */
  abstract upsert(params: {token: string, userConfiguration: UserConfiguration}): Observable<UserConfiguration>;

  /**
   * Delete the user configuration
   */
  abstract delete(): Observable<void>;
}